import { PROVINCES, STEPS_OPTIONS, CHECK_LIST_RISK_KO } from 'store/enums';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  loader: true,
  streetType: null,
  maritalStatus: null,
  profession: null,
  sex: null,
  loaderModal: false,
  controlTitle: '',
  controlMessage: '',
  signType: null,
  provinces: PROVINCES,
  stepsOptions: STEPS_OPTIONS,
  stepsNumber: STEPS_OPTIONS.length,
  checkListRiskKo: CHECK_LIST_RISK_KO,
  headerLogos: {
    logoFrontLeft: null,
    logoFrontRight: null
  },
  footerLogos: [],
  theme: 'default',
  footerPubli: null,
  urlFooterLastStep: null,
  disclaimer: null,
  townsCache: {},
  townsProvinceCodeCache: [],
  legal: {},
  errorPage: {
    notFound: '',
    api: ''
  },
  validatingDocuments: false,
  showFilesSigId: null,
  showFilesTypeDocumentText: null,
  showFilesDocuments: null,
  support: {},
  errorMessage: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
